import Typography, {
  type TypographyProps,
} from '@mui/material/Typography';
import type { ElementType, ReactNode } from 'react';

type TextVariant =
  | 'display'
  | 'title'
  | 'subtitle'
  | 'body'
  | 'label'
  | 'caption'
  | 'overline';

type TextTone = 'default' | 'muted' | 'primary' | 'inverse';

type TextProps = Omit<TypographyProps, 'variant' | 'color'> & {
  variant?: TextVariant;
  tone?: TextTone;
  as?: ElementType;
  children?: ReactNode;
};

const typographyVariant: Record<TextVariant, TypographyProps['variant']> = {
  display: 'h3',
  title: 'h5',
  subtitle: 'h6',
  body: 'body1',
  label: 'subtitle2',
  caption: 'caption',
  overline: 'overline',
};

const toneColor: Record<TextTone, TypographyProps['color']> = {
  default: 'text.primary',
  muted: 'text.secondary',
  primary: 'primary',
  inverse: 'common.white',
};

export const Text = ({
  variant = 'body',
  tone = 'default',
  as,
  ...props
}: TextProps): JSX.Element => {
  return (
    <Typography
      component={as}
      variant={typographyVariant[variant]}
      color={toneColor[tone]}
      {...props}
    />
  );
};
